import React from 'react';
import PostCard from '../PostCard/PostCard';

const PostContainer = ({ allBlog }) => {
    return (
        <main className="post-container" id="lws-postContainer">
            {
                allBlog.map(single => <PostCard key={single.id} {...single}> </PostCard>)
            }
        </main>
    );
};

export default PostContainer;